import {
  InvoiceApplicationFormData,
  InvoiceApplicationFormDataInput,
  TransactableSourceType,
} from '@monetize/types/app';
import { UseFormReturn } from 'react-hook-form';
import { TransactionApplicationTableHeader } from './TransactionApplicationTableHeader';
import { TransactionApplicationTableLayout } from './TransactionApplicationTableLayout';
import { TransactionApplicationTableRow } from './TransactionApplicationTableRow';
import { useTransactionApplicationSelection } from './useTransactionApplicationSelection';

const TABLE_GRID_TEMPLATE_COLUMNS =
  'minmax(auto, 1.25rem) minmax(8rem, auto) repeat(2, minmax(auto, 1fr)) repeat(3, minmax(auto, 8rem))';

// "Apply All" spans every cell after the checkbox: invoice + 5 data columns.
const APPLY_ALL_COL_SPAN = 6;

export interface TransactionApplicationTableProps {
  sourceType: TransactableSourceType;
  formState: UseFormReturn<
    InvoiceApplicationFormDataInput,
    unknown,
    InvoiceApplicationFormData
  >;
  /**
   * Full amount of Payment or Credit
   */
  totalAvailableAmount: number;
  /**
   * Currently unapplied amount of payment or credit
   */
  availableAmount: number;
  isDisabled?: boolean;
}

export const TransactionApplicationTable = ({
  sourceType,
  totalAvailableAmount,
  formState,
  availableAmount,
  isDisabled = false,
}: TransactionApplicationTableProps) => {
  const { checkedState, rows, handleToggleSelectAll } =
    useTransactionApplicationSelection({ formState, totalAvailableAmount });

  return (
    <TransactionApplicationTableLayout
      gridTemplateColumns={TABLE_GRID_TEMPLATE_COLUMNS}
      applyAllColSpan={APPLY_ALL_COL_SPAN}
      header={<TransactionApplicationTableHeader sourceType={sourceType} />}
      checkedState={checkedState}
      isDisabled={isDisabled}
      onToggleSelectAll={handleToggleSelectAll}
    >
      {rows.map((row, i) => (
        <TransactionApplicationTableRow
          key={i}
          index={i}
          row={row}
          formState={formState}
          isDisabled={isDisabled}
          availableAmount={availableAmount}
        />
      ))}
    </TransactionApplicationTableLayout>
  );
};
